import { initializeApp } from "firebase/app"
import {
  Auth,
  User,
  getAuth,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signOut,
} from "firebase/auth"
import * as runtimeVariables from "./runtimeVariables"

export type AuthStatus =
  | "Not Attempted"
  | "Login"
  | "Login Link Requested"
  | "Login Link Failed"
  | "Login Unverified"
  | "Login Failed"
  | "Login Failed Credentials"
  | "Logout Failed"
  | "Error"

initializeApp({
  apiKey: runtimeVariables.FIREBASE_API_KEY,
  authDomain: runtimeVariables.FIREBASE_AUTH_DOMAIN,
  projectId: runtimeVariables.FIREBASE_PROJECT_ID,
  storageBucket: runtimeVariables.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: runtimeVariables.FIREBASE_MESSAGE_SENDING_ID,
  appId: runtimeVariables.FIREBASE_APP_ID,
})

export const firebaseAuth: Auth = getAuth()

export const sendEmailLink = async (email: string): Promise<void> => {
  try {
    await sendSignInLinkToEmail(firebaseAuth, email, {
      url: location.href,
      handleCodeInApp: true,
    })

    window.localStorage.setItem("signInCredential", email)
  } catch (e) {
    if (e instanceof DOMException) {
      throw new Error("Error")
    } else {
      throw new Error("Login Invalid")
    }
  }
}

export const signIn = async (): Promise<User> => {
  try {
    let user: User | undefined
    const email = window.localStorage.getItem("signInCredential")

    if (email) {
      const credential = await signInWithEmailLink(
        firebaseAuth,
        email,
        location.href
      )
      window.localStorage.removeItem("signInCredential")
      user = credential.user
    }

    if (!user) {
      throw new Error("Login Failed Credentials")
    }

    return user
  } catch (e) {
    if (e instanceof DOMException) {
      throw new Error("Error")
    } else if (e.message.includes("Login Failed Credentials")) {
      throw e
    } else {
      throw new Error("Login Failed")
    }
  }
}

export const verifySignInCredentials = async (email: string) => {
  try {
    const { user } = await signInWithEmailLink(
      firebaseAuth,
      email,
      location.href
    )

    return user
  } catch {
    throw new Error("Login Failed")
  }
}

export const logoutUser = async (): Promise<void> => {
  try {
    await signOut(firebaseAuth)
  } catch {
    throw new Error("Login Failed")
  }
}
